export default [
    'Rent or Mortgage Payment',
    'Phone Services',
    'Other Debt Payments & Obligations',
    'Health Insurance',
    'Car Payments',
    'Car Maintenance',
    'Life & Other Personal Insurance',
    'Car Insurance',
    'Utilities - Power Bill',
    'Phone Services',
    'Utilities - Other',
    'Cable / Internet / Streaming',
  ]